import * as React from 'react';
const FormControlContext = /*#__PURE__*/React.createContext(undefined);
export default FormControlContext;